

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl, EBaseUrl } from "../../../Helper/BaseUrl";
import { toastError, toastSuccess } from "../../../Helper/ToastMessage";
// Get Table Data
export const AcknowledgedComplaintGetTableDataAPI = createAsyncThunk("AcknowledgedComplaintGetTableData", async ({ data }) => {
    const {
        M_FinacialYearID,
        M_MonthID,
        FromDate,
        ToDate,
        M_ZoneID,
        M_WardID,
        T_ComplaintDetailsID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,
        handleSetData,
        setOwnerDtails,
        setOfficerVisitCloseComplaint,
        setTodaysComplaintData,
        setTodaysClosedComplaintData,
        handleExportData,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Dashboard/Get_WEB_T_Encroach_ComplaintDetails_For_Officer_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&FromDate=${FromDate}&ToDate=${ToDate}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&T_ComplaintDetailsID=${T_ComplaintDetailsID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    handleExportData && handleExportData()
                    handleSetData && handleSetData(result.data.table)
                    if (Flag == "OwnerDtails") {
                        setOwnerDtails && setOwnerDtails(result.data.table)
                    } if (Flag == "OfficerVisit_CloseComplaint" || Flag == "SocialMedia_CloseComplaint" || Flag == "SarthiPortal_CloseComplaint") {
                        setOfficerVisitCloseComplaint(result.data.table)
                    } if (Flag == "Todays_Complaint") {
                        setTodaysComplaintData && setTodaysComplaintData(result.data.table)
                    } if (Flag == "Todays_ClosedComplaint") {
                        setTodaysClosedComplaintData && setTodaysClosedComplaintData(result.data.table)
                    }

                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const AcknowledgedComplaintGetTableDataSlice = createSlice({
    name: "AcknowledgedComplaintGetTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AcknowledgedComplaintGetTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(AcknowledgedComplaintGetTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(AcknowledgedComplaintGetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const AcknowledgedComplaintGetTableDataReducer = AcknowledgedComplaintGetTableDataSlice.reducer


// Get Table Data Export
export const AcknowledgedComplaintGetExportTableDataAPI = createAsyncThunk("AcknowledgedComplaintGetExportTableData", async ({ data }) => {
    const {
        M_FinacialYearID,
        M_MonthID,
        FromDate,
        ToDate,
        M_ZoneID,
        M_WardID,
        T_ComplaintDetailsID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,
        setGridData,

    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${EBaseUrl}/Dashboard/Get_WEB_T_Encroach_ComplaintDetails_For_Officer_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&FromDate=${FromDate}&ToDate=${ToDate}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&T_ComplaintDetailsID=${T_ComplaintDetailsID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    setGridData && setGridData(result.data.table)
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const AcknowledgedComplaintGetExportTableDataSlice = createSlice({
    name: "AcknowledgedComplaintGetExportTableData",
    initialState: {
        isExportLoading: false,
        ExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AcknowledgedComplaintGetExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(AcknowledgedComplaintGetExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExporttableData = action.payload;
        });
        builder.addCase(AcknowledgedComplaintGetExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExporttableData = null;
            toastError('Something went wrong')
        });
    },
})

export const AcknowledgedComplaintGetExportTableDataReducer = AcknowledgedComplaintGetExportTableDataSlice.reducer

export const AcknowledgeForwardPostAPI = createAsyncThunk("AcknowledgeForwardPost", async ({ data }) => {
    const {
        T_ComplaintDetails_Data,
        M_ZoneID,
        M_WardID,
        Officer_M_UserID,
        Remark,
        M_UserID,
        Flag,
        token,
        handleIsPost,
        setloader
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    const formdata = new FormData();
    formdata.append("T_ComplaintDetails_Data", T_ComplaintDetails_Data);
    formdata.append("M_ZoneID", M_ZoneID);
    formdata.append("M_WardID", M_WardID);
    formdata.append("Officer_M_UserID", Officer_M_UserID);
    formdata.append("Remark", Remark);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Dashboard/Post_WEB_T_Encroach_Complaint_Action_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsPost()
                setloader(false)

            } else {
                toastError(result.message)
                setloader(false)
            }
            return result
        })
})

const AcknowledgeForwardPostSlice = createSlice({
    name: "AcknowledgeForwardPost",
    initialState: {
        isloading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AcknowledgeForwardPostAPI.pending, (state, action) => {
            state.isloading = true;
        });
        builder.addCase(AcknowledgeForwardPostAPI.fulfilled, (state, action) => {
            state.isloading = false;
            state.TableData = action.payload;
        });
        builder.addCase(AcknowledgeForwardPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isloading = false;
            state.isError = true;
            state.TableData = null;

        });
    },
})

export const AcknowledgeForwardPostReducer = AcknowledgeForwardPostSlice.reducer

// ---------------------------------Item List PopUp-------------------

export const ItemListTableDataAPI = createAsyncThunk("ItemListTableData", async ({ data }) => {
    const {
        M_FinacialYearID,
        M_MonthID,
        T_Encroach_CreateSchedulingID,
        T_Encroach_CreateScheduling_OwnerDetailsID,
        T_Encroach_ComplaintDetails_OwnerDetailsID,
        T_ComplaintDetailsID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,
        APIFlag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (APIFlag == "OwnerDtails") {
        url = `${EBaseUrl}/Dashboard/Get_WEB_T_Encroach_ComplainDetails_Wise_Items_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&T_ComplaintDetailsID=${T_ComplaintDetailsID}&T_Encroach_ComplaintDetails_OwnerDetailsID=${T_Encroach_ComplaintDetails_OwnerDetailsID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`
    }
    else {
        url = `${EBaseUrl}/Transaction/Get_T_Encroach_CreateScheduling_Wise_Items_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&T_Encroach_CreateSchedulingID=${T_Encroach_CreateSchedulingID}&T_Encroach_CreateScheduling_OwnerDetailsID=${T_Encroach_CreateScheduling_OwnerDetailsID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&ToTop=${ToTop}`
    }

    return fetch(url, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const ItemListTableDataSlice = createSlice({
    name: "ItemListTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ItemListTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ItemListTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ItemListTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const ItemListTableDataReducer = ItemListTableDataSlice.reducer

// Get Table Data
export const PathakPopUpTableDataAPI = createAsyncThunk("PathakPopUpTableData", async ({ data }) => {
    const {
        M_FinacialYearID,
        M_MonthID,
        T_Encroach_ComplaintDetailsID,
        M_PathakID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,
        setClosedComplaintData,
        T_Encroach_CreateSchedulingID,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (Flag == "ClosedComplaint") {
        url = `${BaseUrl}/Dashboard/Get_WEB_T_Encroach_ComplaintDetails_Pathak_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&T_Encroach_ComplaintDetailsID=${T_Encroach_ComplaintDetailsID}&M_PathakID=${M_PathakID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`
    } else {
        url = `${BaseUrl}/Dashboard/Get_WEB_T_Encroach_CreateScheduling_Pathak_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&T_Encroach_CreateSchedulingID=${T_Encroach_CreateSchedulingID}&M_PathakID=${M_PathakID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`
    }


    return fetch(url, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    if (Flag == 'ClosedComplaint' || Flag == 'Pathak') {
                        setClosedComplaintData(result.data.table)
                    }
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const PathakPopUpTableDataSlice = createSlice({
    name: "PathakPopUpTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PathakPopUpTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PathakPopUpTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PathakPopUpTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const PathakPopUpTableDataReducer = PathakPopUpTableDataSlice.reducer

export const ReceivedReturnPatchAPI = createAsyncThunk("ReceivedReturnPatch", async ({ data }) => {
    const {
        T_ComplaintDetailsID,
        M_ZoneID,
        M_WardID,
        Officer_M_UserID,
        Remark,
        M_UserID,
        Flag,
        token,
        handleIsPost,
        setloader
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    const formdata = new FormData();
    formdata.append("T_ComplaintDetailsID", T_ComplaintDetailsID);
    formdata.append("M_ZoneID", M_ZoneID);
    formdata.append("M_WardID", M_WardID);
    formdata.append("Officer_M_UserID", Officer_M_UserID);
    formdata.append("Remark", Remark);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    const requestOptions = {
        method: "PATCH",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_Encroach_Complaint_Action_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsPost()
                setloader(false)

            } else {
                toastError(result.message)
                setloader(false)
            }
            return result
        })
})

const ReceivedReturnPatchSlice = createSlice({
    name: "ReceivedReturnPatch",
    initialState: {
        isloading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ReceivedReturnPatchAPI.pending, (state, action) => {
            state.isloading = true;
        });
        builder.addCase(ReceivedReturnPatchAPI.fulfilled, (state, action) => {
            state.isloading = false;
            state.TableData = action.payload;
        });
        builder.addCase(ReceivedReturnPatchAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isloading = false;
            state.isError = true;
            state.TableData = null;

        });
    },
})

export const ReceivedReturnPatchReducer = ReceivedReturnPatchSlice.reducer

